import {
	ref,
	onValue,
	getDatabase,
	set,
	get,
	push,
	remove,
	update,
} from "firebase/database";
import {
	getAuth,
	createUserWithEmailAndPassword,
	signInWithEmailAndPassword,
	sendPasswordResetEmail,
} from "firebase/auth";
import fire from "../config/fire";
// import { getCurrentUserDetails } from "../config/getCurrentUserDetails";

const db = getDatabase();
const auth = getAuth(fire);

/* ================= ✅ GET DYNAMIC API PATH ================= */
// const getApiPath = (userId) => {
// 	// const user = getCurrentUserDetails();
// 	// const uid = user?.uid || userId;

// 	// if (!uid) {
// 	// 	console.error("User not authenticated");
// 	// 	window.location.href = "/";
// 	// 	throw new Error("User not authenticated");
// 	// }

// 	return `shops/user_1`;
// };

const getApiPath = (userId) => {
	return `shops/${userId}`;
};

/* ================= CREATE / OVERWRITE (use for config) ================= */
export const setValueToDatabase = async (path, data) => {
	// const apiPath = getApiPath();
	return await set(ref(db, `${path}`), data);
};

/* ================= CREATE MULTIPLE RECORDS ================= */
export const pushValueToDatabase = async (path, data) => {
	const newRef = push(ref(db, `${path}`));
	await set(newRef, data);
	return newRef.key;
};

/* ================= READ ================= */
export const getValueFromDatabase = async (path, uid) => {
	const snapshot = await get(ref(db, `${path}/${uid}`));
	return snapshot.exists() ? snapshot.val() : {};
};

export const listenToFirebase = (path, callback) => {
	const apiPath = getApiPath();
	const dbRef = ref(db, `${apiPath}/${path}`);
	return onValue(dbRef, (snapshot) => {
		const data = snapshot.exists() ? snapshot.val() : {};
		callback(data);
	});
};

/* ================= DELETE ================= */
export const deleteValueFromDatabase = async (path) => {
	const apiPath = getApiPath();
	return await remove(ref(db, `${apiPath}/${path}`));
};

/* ================= UPDATE ================= */
export const updateValueToDatabase = async (path, data) => {
	const apiPath = getApiPath();
	return await update(ref(db, `${apiPath}/${path}`), data);
};

/* ================= AUTH ================= */
export const registerUser = async (email, password) => {
	return await createUserWithEmailAndPassword(auth, email, password);
};

export const loginUser = async (email, password) => {
	return await signInWithEmailAndPassword(auth, email, password);
};

/* ================= FORGOT PASSWORD ================= */
export const forgotPassword = async (email) => {
	return await sendPasswordResetEmail(auth, email);
};
